import { css } from '@emotion/css';

const alertContainer = css({
  marginTop: '0.5rem',
  '& .MuiAlert-message': {
    width: '100%',
  },
});

const messageText = css({
  '&&': {
    display: 'block',
  },
});

const loadingContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.25rem',
});

const loadingText = css({
  '&&': {
    fontSize: '0.75rem',
  },
});

const RateValidationAlertStyles = {
  alertContainer,
  messageText,
  loadingContainer,
  loadingText,
};

export default RateValidationAlertStyles;
